<div class="categories-container">
	<div class="category">
		<p class="title">{{ 'EXTERNALREGISTRATIONFORM.CATEGORIES.PERSONAL' | translate | uppercase }}</p>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="firstName"
						 #firstName="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.FIRSTNAME.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.firstName">
			<mat-error *ngIf="firstName.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="lastName"
						 #lastName="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.LASTNAME.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.lastName">
			<mat-error *ngIf="lastName.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>

		<def-password-input [member]="member"></def-password-input>

		<mat-form-field floatLabel="always">
			<input matInput
						 type="email"
						 name="email"
						 email
						 #email="ngModel"
						 required
						 pattern="^(?!.*decathlon[.]com$).*$"
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.EMAIL.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.email">
			<mat-error *ngIf="email.invalid && !email.errors?.pattern">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
			<mat-error *ngIf="email.errors?.pattern">{{ 'EXTERNALREGISTRATIONFORM.INVALIDPATTERN' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="tel"
						 name="phoneNumber"
						 #phoneNumber="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.PHONENUMBER.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.phoneNumber">
			<mat-error *ngIf="phoneNumber.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<def-country-input [member]="member"></def-country-input>
	</div>

	<div class="category">
		<p class="title">{{ 'EXTERNALREGISTRATIONFORM.CATEGORIES.COMPANY' | translate | uppercase }}</p>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyName"
						 #companyName="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYNAME.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyName">
			<mat-error *ngIf="companyName.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyCommercialName"
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYCOMMERCIALNAME.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyCommercialName">
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyAddress"
						 #companyAddress="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYADDRESS.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyAddress">
			<mat-error *ngIf="companyAddress.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyAddressComplement"
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYADDRESSCOMPLEMENT.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyAddressComplement">
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyZipCode"
						 #companyZipCode="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYZIPCODE.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyZipCode">
			<mat-error *ngIf="companyZipCode.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyCity"
						 #companyCity="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYCITY.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyCity">
			<mat-error *ngIf="companyCity.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyImmatriculationNumber"
						 #companyImmatriculationNumber="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYIMMATRICULATIONNUMBER.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyImmatriculationNumber">
			<mat-error *ngIf="companyImmatriculationNumber.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyVatNumber"
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYVATNUMBER.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyVatNumber">
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyManagerFirstName"
						 #companyManagerFirstName="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYMANAGERFIRSTNAME.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyManagerFirstName">
			<mat-error *ngIf="companyManagerFirstName.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyManagerLastName"
						 #companyManagerLastName="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYMANAGERLASTNAME.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyManagerLastName">
			<mat-error *ngIf="companyManagerLastName.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyManagerJob"
						 #companyManagerJob="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYMANAGERJOB.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyManagerJob">
			<mat-error *ngIf="companyManagerJob.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="email"
						 email
						 name="companyManagerEmail"
						 #companyManagerEmail="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYMANAGEREMAIL.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyManagerEmail">
			<mat-error *ngIf="companyManagerEmail.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyAccountantFirstName"
						 #companyAccountantFirstName="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYACCOUNTANTFIRSTNAME.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyAccountantFirstName">
			<mat-error *ngIf="companyAccountantFirstName.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyAccountantLastName"
						 #companyAccountantLastName="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYACCOUNTANTLASTNAME.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyAccountantLastName">
			<mat-error *ngIf="companyAccountantLastName.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="companyAccountantJob"
						 #companyAccountantJob="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYACCOUNTANTJOB.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyAccountantJob">
			<mat-error *ngIf="companyAccountantJob.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="email"
						 email
						 name="companyAccountantEmail"
						 #companyAccountantEmail="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.COMPANYACCOUNTANTEMAIL.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.companyAccountantEmail">
			<mat-error *ngIf="companyAccountantEmail.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
	</div>
</div>
